import React, { useState } from 'react';
import { flightSummary, suggestionLine } from '../../lib/flightPickup';
import { applyFlightSuggestion, dismissFlightSuggestion } from '../../lib/tripFlight';

// FA-2: the flight line on a Dispatch Board / Schedule trip card. A flight change never moves the pickup by itself: it shows
// "Flight delayed 40 min · suggested pickup 4:15 PM · Apply", and dispatch decides with one tap (or keeps the current pickup).
export default function FlightSuggestionCard({ detail, client, canEdit = false, timeZone, onChanged }) {
    const [busy, setBusy] = useState(false);
    const [error, setError] = useState('');
    const summary = flightSummary(detail);
    if (!summary) return null;
    const line = suggestionLine(detail, { timeZone });

    const act = async (action) => {
        setBusy(true);
        setError('');
        try {
            if (action === 'apply') await applyFlightSuggestion(client, detail.engagement_id);
            else await dismissFlightSuggestion(client, detail.engagement_id);
            if (onChanged) await onChanged();
        } catch (failure) {
            setError(failure?.message || 'That did not work. Try again.');
        } finally {
            setBusy(false);
        }
    };

    return (
        <div className="mt-1 text-xs" data-testid="flight-line">
            <p className="text-[var(--ink-muted)]">✈️ {summary}</p>
            {line && (
                <div className="mt-1" data-testid="flight-suggestion" role="status">
                    <span className="ia-resv-tag">{line}</span>
                    {canEdit && (
                        <span className="ml-1 inline-flex gap-1">
                            <button type="button" className="ia-btn3d ia-btn3d--pill" disabled={busy} onClick={() => act('apply')}>Apply</button>
                            <button type="button" className="ia-btn3d ia-btn3d--pill" disabled={busy} onClick={() => act('dismiss')}>Keep current pickup</button>
                        </span>
                    )}
                </div>
            )}
            {error && <p role="alert" className="mt-1 text-red-700">{error}</p>}
        </div>
    );
}
